<template>
  <div>
    <DocumentHeader header="หน้าใบส่งคืนสินค้า (รอการอัพเดท)" link_back="stock/document/returnproductreceipt"/>
    <Document_details/>
  </div>
</template>

<script>
import DocumentHeader from "@/components/admin/document_stock/header_document/DocumentHeader";
import Document_details from "@/components/admin/document_stock/Document_details";

export default {
  name: "DocumentDetails",
  components: {
    Document_details,
    DocumentHeader
  }
}
</script>

<style scoped>

</style>
